<script setup>
import { defineComponent, ref, computed, getCurrentInstance } from 'vue'
import axios from 'axios'
import { loadPayline } from '@/payline-helper.js'
import router from '@/router/index.js'

defineComponent({
  name: 'FabricationCarte',
})
const prenom = ref(null);
const nom = ref(null);
const adresse = ref(null);
const codePostal = ref(null);
const ville = ref(null);
const complementAdresse = ref(null);
const pays = ref("France");
const dateNaissance = ref(null);
const email = ref(null);
const mobile = ref();
const imageFile = ref(null);
const justificatifDetenteurFile = ref(null);
const justificatifSignataireFile = ref(null);
const imageValidationMessage = ref("");
const justificatifValidationMessage = ref("");
const justificatifValidationMessageDetenteur = ref("");
const visibiliteJustificatif = ref(true);
const isFuturDetenteur = ref(false);

const montantFabricationCarte = ref(5.0);

const erreurMessage = ref(null);

const paysList = ref(["France", "Allemagne", "Andorre", "Belgique", "Espagne", "Italie", "Luxembourg", "Monaco", "Suisse"]);

const loading = ref(false);
const paymentToken = ref(undefined);
const isRenseignementsChecked = ref(null);
const isRGPDChecked = ref(null);
const needFacture = ref(false);
const isAchatCollapsed = ref(false);
const isPaiementCollapsed = ref(true);
const { proxy } = getCurrentInstance()


const MAX_FILE_SIZE = 1.5 * 1024 * 1024;
const MAX_TOTAL_SIZE = 3 * 1024 * 1024;

//function de gestion
function validationFormulaire(e) {
  e.preventDefault();
  creationVente();
}

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value;
  isPaiementCollapsed.value = !isPaiementCollapsed.value;
}

function onChangeImageFile(event) {
  const file = event.target.files[0];

  if (!file) {
    return;
  }

  if (file.size > MAX_FILE_SIZE) {
    imageValidationMessage.value = `Le fichier "${file.name}" dépasse la taille maximale autorisée de ${MAX_FILE_SIZE / (1024*1024)} Mo.`;
    event.target.value = null;
    imageFile.value = null;
    return;
  }

  if (file && (file.type !== 'image/jpeg' && file.type !== 'image/png')) {
    imageValidationMessage.value = "Format incorrect. Veuillez télécharger une image JPG ou PNG.";
    event.target.value = null;
  } else {
    imageValidationMessage.value = "";
    imageFile.value = file;
  }
}

function onChangeJustificatifDetenteurFile(event) {
  const file = event.target.files[0];

  if (!file) {
    return;
  }

  if (file.size > MAX_FILE_SIZE) {
    justificatifValidationMessage.value = `Le fichier "${file.name}" dépasse la taille maximale autorisée de ${MAX_FILE_SIZE / (1024*1024)} Mo.`;
    event.target.value = null;
    imageFile.value = null;
    return;
  }

  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessage.value = "Format incorrect. Veuillez télécharger un PDF";
    event.target.value = null;
  } else {
    justificatifValidationMessage.value = "";
    justificatifDetenteurFile.value = file;
  }
}

function onChangeJustificatifSignataireFile(event) {
  const file = event.target.files[0];

  if (!file) {
    return;
  }

  if (file.size > MAX_FILE_SIZE) {
    justificatifValidationMessageDetenteur.value = `Le fichier "${file.name}" dépasse la taille maximale autorisée de ${MAX_FILE_SIZE / (1024*1024)} Mo.`;
    event.target.value = null;
    imageFile.value = null;
    return;
  }

  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessageDetenteur.value = "Format incorrect. Veuillez télécharger un PDF";
    event.target.value = null;
  } else {
    justificatifValidationMessageDetenteur.value = '';
    justificatifSignataireFile.value = file;
  }
}

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  })
  return formatter.format(value);
}

function creationVente() {
  if (loading.value) {
    return;
  } else {
    loading.value = true;
  }

  let totalSize = 0;
  if (imageFile.value) {
    totalSize += imageFile.value.size;
  }
  if (justificatifDetenteurFile.value) {
    totalSize += justificatifDetenteurFile.value.size;
  }
  if (justificatifSignataireFile.value) {
    totalSize += justificatifSignataireFile.value.size;
  }

  if (totalSize > MAX_TOTAL_SIZE) {
    erreurMessage.value = `La taille totale des fichiers dépasse ${MAX_TOTAL_SIZE / (1024*1024)} Mo. Merci de réduire vos fichiers.`;
    loading.value = false;
    return;
  }


  const formData = new FormData();
  formData.append('prenom', prenom.value);
  formData.append('nom', nom.value);
  formData.append('adresse', adresse.value);
  formData.append('codePostal', codePostal.value);
  formData.append('ville', ville.value);
  formData.append('complementAdresse', complementAdresse.value);
  formData.append('pays', pays.value);
  formData.append('dateNaissance', dateNaissance.value);
  formData.append('email', email.value);
  formData.append('mobile', mobile.value);
  formData.append('montant', montantFabricationCarte.value);
  formData.append('imageFile', imageFile.value);
  formData.append('identiteFile', justificatifDetenteurFile.value);
  formData.append('justificatifFile', justificatifSignataireFile.value);
  formData.append('isRenseignementsChecked', isRenseignementsChecked.value);
  formData.append('isRGPDChecked', isRGPDChecked.value);
  formData.append('needFacture', needFacture.value);
  formData.append('support', 'NFC');
  formData.append('reductionId', null);
  formData.append('codeProduit', null);

  console.log('Creation vente')
  axios
    .post('commandes/prepareFabricationCarte', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(
      () => {
        router.push('/succes-fabrication-carte')
      },
      reason => {
        if (reason.response.status === 402) {
          paymentToken.value = reason.response.data.token
          loadPayline(reason.response.data.production).then(() => {
            toggleCollapse()
            proxy.$root.$emit('bv::toggle::collapse', 'achat')
            proxy.$root.$emit('bv::toggle::collapse', 'paiement')
          })
        } else {
          console.error('ERREUR', reason.response);
          if (reason.response.status === 413) {
            erreurMessage.value = "Les fichiers sont trop volumineux (max 5Mo au total).";
          } else {
            erreurMessage.value = reason.response.data;
          }
          this.$bvModal.show('modal_erreur');
        }
      },
    )
    .finally( () => {
      loading.value = false;
    })
}

function validerDate() {
  erreurMessage.value = ""
  if (!dateNaissance.value) {
    return;
  }

  if (!dateNaissance.value.match(/^(\d{4})-\d{2}-\d{2}$/)) {
    erreurMessage.value = 'Erreur: mauvais format de date'
    dateNaissance.value = null
  }
}

const montantFormate = computed(() => {
  return montantFabricationCarte.value.toFixed(2).replace('.', '€');
});

function recommencerAchat() {
  window.location.reload()
}
</script>

<template>
  <div :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }" role="tablist" class="overflow-auto">
    <div role="tabpanel">
      <form @submit="validationFormulaire">
        <div class="achat container">
          <h1>Commande de carte</h1>

          <h2>La création de cette carte personnalisée sera facturée {{ montantFormate }}</h2>

          <div class="form_fabrication_carte pt-sm-5">
            <div class="carte_fabrication_carte card">
              <div class="card-body">
                <div>
                  <p style="text-align: center">Indiquez les informations du titulaire du titre de transport</p>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-user fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input v-model="nom" type="text" class="form-control" placeholder="Nom" required>
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-11 col-xs-10 offset-sm-1">
                      <input v-model="prenom" type="text" class="form-control" placeholder="Prénom" required>
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fa-solid fa-location-dot fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input v-model="adresse" type="text" class="form-control" placeholder="Adresse" required>
                    </div>
                  </div>

                  <div class="div_icon_input row">
                        <div class="col-5 offset-sm-1">
                          <input v-model="codePostal" type="text" class=" form-control input-adresse" placeholder="Code Postal" required>
                        </div>
                        <div class="col-7 col-sm-6">
                          <input v-model="ville" type="text" class="form-control" placeholder="Ville" required>
                        </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-11 col-xs-10 offset-sm-1">
                      <input v-model="complementAdresse" type="text" class="form-control" placeholder="Complément d'adresse (Numéro appartement, Bâtiment, etc)">
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fa-solid fa-flag fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <select v-model="pays" class="form-control" required>
                        <option disabled :value="null">Veuillez sélectionner un pays</option>
                        <option v-for="item in paysList" :key="item" :value="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-envelope"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input v-model="email" type="email" class="form-control" id="exampleFormControlInput1"
                             placeholder="Adresse E-mail" required>
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-mobile"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input v-model="mobile" type="tel" maxlength="12" class="form-control" id="telFormControlInput"
                             placeholder="Mobile avec indicatif (+33 pour la France)" required>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-1 d-none d-sm-block">
                    </div>
                    <label for="dateDeNaissance" class="col-sm-11 col-xs-10">Date de naissance</label>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-calendar"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                      type="date"
                      class="form-control"
                      @change="validerDate"
                      v-model="dateNaissance"
                      id="dateDeNaissance"
                      required
                    >
                  </div>
                </div>

                <p class="mt-3 mt-sm-5">Personnalisez la carte avec la photo d'identité du futur détenteur (Photo cadrée, droite et nette)</p>
                <div class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-file"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <input
                      ref="imageInput"
                      type="file"
                      @change="onChangeImageFile"
                      accept="image/jpeg"
                      class="form-control"
                      required
                    />
                    <p :style="{ color: imageValidationMessage.value === 'Format correct.' ? 'green' : 'red' }">
                      {{ imageValidationMessage }}
                    </p>
                  </div>
                </div>

                <p class="mt-1">Merci de fournir une pièce d’identité du détenteur</p>
                <div v-if=visibiliteJustificatif class="div_icon_input row">
                  <div class="col-sm-1 text-center d-none d-sm-block">
                    <i class="fas fa-file"></i>
                  </div>
                  <div class="col-sm-11 col-xs-10">
                    <input
                      ref="justificatifInput"
                      type="file"
                      @change="onChangeJustificatifDetenteurFile"
                      accept="application/pdf"
                      class="form-control"
                      multiple
                      required
                    />
                    <p :style="{ color: justificatifValidationMessage.value === 'Format correct.' ? 'green' : 'red' }">
                      {{ justificatifValidationMessage }}
                    </p>
                  </div>
                </div>

                  <p><input v-model="isFuturDetenteur" type="checkbox"> Cochez si vous n'êtes pas le futur détenteur de la carte</p>

                  <p v-if="isFuturDetenteur" class="mt-1 mt-sm-2">
                    Merci de fournir une pièce d'identité du signataire
                  </p>

                  <div v-if="isFuturDetenteur" class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="justificatifInput"
                        type="file"
                        @change="onChangeJustificatifSignataireFile"
                        accept="application/pdf"
                        class="form-control"
                        multiple
                        required
                      />
                      <p :style="{ color: justificatifValidationMessageDetenteur.value === 'Format correct.' ? 'green' : 'red' }">
                        {{ justificatifValidationMessageDetenteur }}
                      </p>
                    </div>
                  </div>

                  <p style="text-align: justify; font-weight: normal">
                    Les informations recueillies par Riv’Connect, à partir de ce formulaire, font l’objet d’un traitement informatisé nécessaire à la gestion des relations commerciales et au suivi de votre demande. Ces données sont destinées à Riv’Connect, qui est responsable de traitement, ainsi que, le cas échéant à ses partenaires, sous-traitants ou prestataires situés dans ou hors de l’Union Européenne et aux filiales du Groupe Keolis. Vos données sont conservées pour la durée nécessaire au traitement de votre demande, à la gestion administrative et comptable des services souscrits et la promotion des services.<br>
                    Pour plus d’informations, nous vous invitons à consulter notre <a class="lien" target="_blank" href="Politique-de-confidentialite-RivConnect.pdf">Politique de confidentialité</a>.<br>
                    Conformément à la règlementation applicable, vous disposez d’un droit d’accès, de rectification et/ou de suppression de vos données personnelles. Vous pouvez également vous opposer à leur traitement à des fins commerciales. Vous pouvez exercer ces droits, ou adresser toute autre question aux coordonnées postales ou électroniques disponibles précédemment indiquées.<br>
                  </p>

                  <p> <input v-model="isRenseignementsChecked" type="checkbox" required> Je certifie l'exactitude des renseignements fournis dans ce formulaire.</p>

                  <p> <input v-model="isRGPDChecked" type="checkbox" required> J’ai lu et compris la déclaration de confidentialité quant à la protection, le stockage et l’utilisation de mes données personnelles et donne mon consentement pour le traitement de toutes les données fournies dans mon dossier électronique dans le cadre de ma demande, y compris l’utilisation par des organisations externes.</p>

                  <p> <input v-model="needFacture" type="checkbox"> Je souhaite avoir une facture.</p>

                  <div class="text-center">
                    <button type="submit" class="btn btn-vert">
                      <i class="fas fa-arrow-right"></i>
                      Valider
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div id="modal_erreur" title="Erreur...">
      <div class="carte">
        <div>
          <p class="description error">{{ erreurMessage }}</p>
        </div>
      </div>
    </div>
  </div>

  <div
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    role="tabpanel"
  >
    <div class="paiement container">
      <h1>Finalisation de votre achat - Paiement</h1>
      <h2>Récapitulatif de votre achat</h2>

      <div class="carte_recap card">
        <div class="card-body">
          <h5 class="card-text">Titulaire : {{ prenom }} {{ nom }}</h5>
          <h5 class="card-text">Produit : Carte</h5>
          <h5 class="card-text">
            Montant : {{ toCurrency(montantFabricationCarte) }}
          </h5>
        </div>
      </div>
      <div id="PaylineWidget"
           :data-token="paymentToken"
           data-template="column"
           data-auto-init="true"
           data-embeddedredirectionallowed="false"
      />
    </div>
  </div>

  <div class="modal fade" id="modal_erreur" tabindex="-1" aria-labelledby="modalErreurLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalErreurLabel">Erreur...</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="carte">
            <div>
              <p class="description error">{{ erreurMessage }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="recommencerAchat">Fermer
          </button>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal_erreur" tabindex="-1" aria-labelledby="modalErreurLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErreurLabel">Erreur...</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="carte">
              <div>
                <p class="description error">{{ erreurMessage }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="recommencerAchat">Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

.md-steppers .md-steppers-navigation {
  display: none;
}

.form_fabrication_carte {
  .carte_fabrication_carte {
    border: none !important;

    .bouton_valid {
      display: block;
      margin: auto;
      @include boutons;
    }

    .bouton_valid:hover {
      @include boutons_hover;
    }

    .div_icon_input {
      display: flex;
      margin-bottom: 1rem;
      @include icon_form;

      &:focus-within {
        i {
          color: var(--color-bleu-logo);
        }
      }
    }
  }
}

.error {
  color: red !important;
}
</style>
